import React from 'react'
import PropTypes from 'prop-types'
import ReactModal from 'react-modal'
import i18n from 'i18next'
import Button from '#components/a/Button'
import ControlsGroup from './ControlsGroup'
import {LoadingButton} from '#components/m/LoadingButton'
import useOnPressEscKey from '#hooks/onKeyPress/useOnPressEscKey'

/* eslint-disable */
if (process.env.NODE_ENV !== 'test') ReactModal.setAppElement('#azubiguide')
/* eslint-enable */

function ModalByProps(props) {
  const {
    testId,
    modalIsOpen,
    closeModal,
    handleConfirm,
    confirmButtonDisabled,
    confirmButtonDisabledReason,
    modifier,
    children,
    confirmText,
    callbackIsExecuting,
    confirmLoadingText,
    confirmButtonTitle,
  } = props

  useOnPressEscKey(closeModal)

  const preventDefault = e => {
    e.preventDefault()
  }

  return (
    <div className="modal__wrap">
      <ReactModal
        testId={testId}
        isOpen={modalIsOpen}
        className={`modal modal--${modifier}`}
        overlayClassName="modal__overlay"
      >
        <form onSubmit={preventDefault}>
          {children}
          {closeModal && handleConfirm && (
            <ControlsGroup>
              <Button event={closeModal} text={i18n.t('misc_cancel')} variant="secondary" />
              <LoadingButton
                type="submit"
                isLoading={callbackIsExecuting || false}
                id="modalConfirmButton"
                testid="modalConfirmButton"
                disabled={confirmButtonDisabled}
                disabledReason={confirmButtonDisabledReason}
                title={confirmButtonTitle}
                event={handleConfirm}
                text={confirmText || i18n.t('misc_confirm')}
                loadingText={confirmLoadingText || confirmText || i18n.t('misc_confirm')}
                variant="primary"
              />
            </ControlsGroup>
          )}
        </form>
      </ReactModal>
    </div>
  )
}

ModalByProps.propTypes = {
  testId: PropTypes.string,
  modalIsOpen: PropTypes.bool,
  closeModal: PropTypes.func,
  handleConfirm: PropTypes.func,
  confirmButtonDisabled: PropTypes.bool,
  confirmButtonDisabledReason: PropTypes.string,
  modifier: PropTypes.string,
  children: PropTypes.node,
  confirmText: PropTypes.string,
  confirmButtonTitle: PropTypes.string,
  callbackIsExecuting: PropTypes.bool,
  confirmLoadingText: PropTypes.string,
}

export default ModalByProps
